// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"TruncateTextWithTooltip_ellipsis__8D_HN","tooltip":"TruncateTextWithTooltip_tooltip__Vuc84"};